var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframeContainer",staticClass:"Webpage-responsive w-100 h-100"},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"2000px","allowFullScreen":"","title":"Embedded Website"},on:{"load":_vm.startScrolling}})])
}
var staticRenderFns = []

export { render, staticRenderFns }